import React from 'react';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';
import { BaasicInput, BaasicButton, BaasicWarningModal, Loader, SliderCheckBox, BaasicDropdown } from 'core/components';
import { timer } from 'core/utils';
import { channelType } from 'common/constants';
import { observer } from 'mobx-react';

const ProductEditGeneralStep = observer(
	({
		t,
		form,
		viewStore: {
			loading,
			productIdForPart,
			displaySellerDropdown,
			productId,
			addUpcField,
			sellerDropdownStore,
			conditionDropdownStore,
			productStatusDropdownStore,
			productCategoryDropdownStore,
			setRules,
		},
	}) => {
		if (loading) return <Loader />;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
						<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.GENERALSTEP')}</h3>
						<div className="spc--bottom--sml">
							<div className="flex--primary flex--gap--6">
								{displaySellerDropdown && !productId && !productIdForPart && (
									<BaasicDropdown
										dropdownStore={sellerDropdownStore}
										isClearable={true}
										placeholder={t('PLACEHOLDER.SELLER')}
										className="w--200--px"
									/>
								)}
							</div>
						</div>
						{productIdForPart && <BaasicInput field={form.$('productPartQuantity')} />}
						<div className="row">
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<BaasicInput autoFocus field={form.$('mainSku')} />
							</div>
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<BaasicInput autoFocus field={form.$('name')} />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<div className="inputgroup spc--bottom--sml">
									<BaasicDropdown dropdownStore={productStatusDropdownStore} isClearable={true} />
								</div>
							</div>
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<div className="inputgroup spc--bottom--sml">
									<BaasicDropdown dropdownStore={productCategoryDropdownStore} isClearable={true} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<BaasicInput field={form.$('description')} />
							</div>
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<BaasicInput field={form.$('asin')} className="w--100" />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<BaasicInput field={form.$('nmfcCode')} className="w--100" />
							</div>
							<div className="col col-sml-6 col-lrg-6 col-xxlrg-6">
								<BaasicInput field={form.$('freightClassCode')} className="w--100" />
							</div>
						</div>
					</div>
					<div className="col col-sml-0.5 col-lrg-0.5 col-xxlrg-0.5"></div>
					<div className="col col-sml-5 col-lrg-5 col-xxlrg-5">
						<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.SHIPPING')}</h3>
						<div className="row">
							<div className="col col-sml-8 col-lrg-8 col-xxlrg-8">
								<div className="spc--bottom--sml">
									<div className="flex--primary flex--gap--6">
										{!productIdForPart && (
											<div className="input--toggle--custom spc--bottom--sml">
												<SliderCheckBox field={form.$('isShippable')} onChangeCallback={() => setRules()} />
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						{form.$('isShippable').value && (
							<React.Fragment>
								<div className="row">
									<div className="col col-sml-8 col-lrg-8 col-xxlrg-8">
										<div className="spc--bottom--sml">
											<div className="flex--primary flex--gap--6">
												{!productIdForPart && form.$('isShippable').value && (
													<div className="input--toggle--custom spc--bottom--sml">
														<SliderCheckBox field={form.$('isMultiProduct')} onChangeCallback={() => setRules()} />
													</div>
												)}
												{form.$('isShippable').value && (
													<div className="input--toggle--custom spc--bottom--sml">
														<SliderCheckBox field={form.$('onePerBox')} />
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col col-sml-8 col-lrg-8 col-xxlrg-8">
										<div className="inputgroup spc--bottom--sml">
											<BaasicDropdown dropdownStore={conditionDropdownStore} isClearable={true} />
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col col-sml-8 col-lrg-8 col-xxlrg-8">
										<p className="type--med title--primary">
											<b>{t('PRODUCT.WIZARD.UPCS')}</b>
										</p>
									</div>
								</div>
								<div className="row">
									<div className="col col-sml-8 col-lrg-8 col-xxlrg-8">
										{form.$('productUpcs').map(productUpc => {
											return (
												<React.Fragment key={productUpc.id}>
													<BaasicInput
														field={productUpc.$('upc')}
														innerClassName={form.$('productUpcs').value.length > 1 ? 'input--single-row' : ''}
														iconClass={
															form.$('productUpcs').value.length > 1
																? 'fa fa-trash type--color--warning k-custom-clickable'
																: ''
														}
														onIconClick={() => form.$('productUpcs').del(productUpc.key)}
														className="input--no-label--first-child"
													/>
												</React.Fragment>
											);
										})}
										<BaasicButton
											className="btn btn--med btn--secondary spc--bottom--sml"
											type="button"
											onClick={addUpcField}
											icon="fa fa-plus spc--right--sml"
											label="PRODUCT.WIZARD.ADDUPC"
										/>
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</React.Fragment>
		);
	}
);

const ProductEditDimensionsStep = observer(
	({
		t,
		form,
		stepForm,
		viewStore: {
			loading,
			conflictWarningModal,
			openCreateBoxModal,
			onPoundsChange,
			setRules,
			dimensionUnitDropdownStore,
			weightUnitDropdownStore,
			boxDropdownStore,
		},
	}) => {
		if (loading) return <Loader />;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col col-sml-3">
						<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.DIMENSIONSSTEP')}</h3>
					</div>
				</div>
				<div className="row">
					<div className="col col-sml-3">
						<BaasicDropdown
							dropdownStore={dimensionUnitDropdownStore}
							isDisabled={!stepForm.$('generalStep.isShippable').value}
							className="spc--bottom--sml flex--grow--1"
						/>
					</div>
					<div className="col col-sml-4">
						<BaasicDropdown
							dropdownStore={weightUnitDropdownStore}
							isDisabled={!stepForm.$('generalStep.isShippable').value}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col col-sml-3">
						<BaasicInput field={form.$('length')} disabled={!stepForm.$('generalStep.isShippable').value} />
					</div>
					{_.get(weightUnitDropdownStore, 'value.label') == 'Kilograms' ? (
						<div className="col col-sml-4 col-lrg-4 spc--bottom--sml">
							<BaasicInput field={form.$('weight')} disabled={!stepForm.$('generalStep.isShippable').value} />
						</div>
					) : (
						<React.Fragment>
							<div className="col col-sml-2 col-lrg-2 spc--bottom--sml">
								<BaasicInput
									onKeyUp={() => timer(onPoundsChange, form.$('pounds').value, 1000)}
									field={form.$('pounds')}
									disabled={!stepForm.$('generalStep.isShippable').value}
								/>
							</div>
							<div className="col col-sml-2 col-lrg-2 spc--bottom--sml">
								<BaasicInput
									onKeyUp={() => setRules()}
									field={form.$('ounces')}
									disabled={!stepForm.$('generalStep.isShippable').value}
								/>
							</div>
						</React.Fragment>
					)}
				</div>
				<div className="row">
					<div className="col col-sml-3">
						<BaasicInput field={form.$('width')} disabled={!stepForm.$('generalStep.isShippable').value} />
					</div>
				</div>
				<div className="row">
					<div className="col col-sml-3">
						<BaasicInput field={form.$('height')} disabled={!stepForm.$('generalStep.isShippable').value} />
					</div>
				</div>
				<div className="row">
					<div className="col col-sml-3">
						<BaasicDropdown
							dropdownStore={boxDropdownStore}
							isClearable={true}
							className="spc--bottom--tny flex--grow--1"
							isDisabled={!stepForm.$('generalStep.isShippable').value}
						/>
					</div>
				</div>
				<div className="spc--bottom--sml">
					<SliderCheckBox field={form.$('automaticBox')} disabled={!stepForm.$('generalStep.isShippable').value} />
				</div>
				<div className="spc--top--sml">
					<BaasicButton
						label={'ADDNEWBOX'}
						className="btn btn--med btn--primary"
						onClick={openCreateBoxModal}
						type="button"
						disabled={!stepForm.$('generalStep.isShippable').value}
						icon="fa fa-plus spc--right--sml"
					/>
				</div>
				<BaasicWarningModal modalParams={conflictWarningModal} />
			</React.Fragment>
		);
	}
);

const ProductEditVirtualSKUStep = observer(
	({
		t,
		form,
		stepForm,
		viewStore: {
			onDeleteVirtualSkuCallback,
			addVirtualSku,
			conflictWarningModal,
			disableUpdateInventory,
			isActive,
			rootStore,
			channel,
		},
	}) => {
		return (
			<React.Fragment>
				<div className="row">
					<div className="col col-sml-12 col-xxlrg-10">
						<div className="flex--secondary">
							<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.VIRTUALSKUSTEP')}</h3>
							<button
								className="btn btn--med btn--secondary spc--bottom--sml"
								onClick={() => addVirtualSku(false)}
								type="button"
							>
								<i className="fa fa-plus spc--right--sml"></i> {t('PRODUCTVIEW.PRODUCTVIRTUALSKUADD')}
							</button>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col col-sml-12 col-lrg-12 col-xxlrg-10 spc--bottom--tny">
						{form.$('productVirtualSkus').map(productVirtualSkuField => {
							return (
								<div className="box--secondary box--sml spc--bottom--tny" key={productVirtualSkuField.key}>
									<div className="row">
										<div className="col col-sml-12">
											<div className="inputgroup type--right">
												<button
													className="btn btn--med btn--ghost react-filter-box-close"
													onClick={e =>
														stepForm.onDeleteArrayField(
															e,
															productVirtualSkuField,
															form.$('productVirtualSkus'),
															onDeleteVirtualSkuCallback
														)
													}
													type="button"
												>
													<i className="fa fa-times"></i>
												</button>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col col-sml-12 col-lrg-2 col-xxlrg-2">
											<BaasicInput field={productVirtualSkuField.$('sku')} />
										</div>
										<div className="col col-sml-12 col-lrg-3 col-xxlrg-2">
											<BaasicDropdown
												dropdownStore={productVirtualSkuField.channelDropdownStore}
												isdisabled={channel && channel.id === productVirtualSkuField.$('channelId').value}
											/>
										</div>
										{stepForm.$('generalStep.isShippable').value && (
											<div className="col col-sml-12 col-lrg-3 col-xxlrg-3">
												<BaasicDropdown
													dropdownStore={productVirtualSkuField.carrierDropdownStore}
													isDisabled={[undefined, channelType.amazonVendor].includes(
														_.get(productVirtualSkuField, 'channelDropdownStore.value.extra.channelType.name')
													)}
													additionalLabel={() => (
														<CarrierDropdownTooltip
															channel={productVirtualSkuField.channelDropdownStore.value}
															rootStore={rootStore}
														/>
													)}
												/>
											</div>
										)}

										<div className="col col-sml-12 col-lrg-2 col-xxlrg-2">
											<BaasicInput field={productVirtualSkuField.$('description')} />
										</div>
										<div className="col col-sml-12 col-lrg-2 col-xxlrg-3">
											<div className="input--toggle--custom display--ib spc--right--med">
												<div
													data-tip={!isActive ? t('PRODUCT.WIZARD.MAINSKUDISABLEDOPTION') : null}
													className="input--toggle--custom display--ib spc--right--med"
												>
													<SliderCheckBox
														onChangeCallback={e =>
															(productVirtualSkuField.$('postInventory').value = e.currentTarget.checked)
														}
														disabled={!isActive}
														field={productVirtualSkuField.$('isActive')}
													/>
												</div>
											</div>
											{stepForm.$('generalStep.isShippable').value && (
												<div
													data-tip={
														!isActive ||
														(productVirtualSkuField.$('isActive') != null &&
															!productVirtualSkuField.$('isActive').value) ||
														disableUpdateInventory(productVirtualSkuField.channelDropdownStore.value)
															? !isActive
																? t('PRODUCT.WIZARD.MAINSKUDISABLEDOPTION')
																: productVirtualSkuField.$('isActive') != null &&
																  !productVirtualSkuField.$('isActive').value
																? t('PRODUCT.WIZARD.VIRTUALSKUDISABLEDOPTION')
																: t('PRODUCT.WIZARD.POSTINVENTORYCHANNELOFF')
															: ''
													}
													className="input--toggle--custom display--ib spc--right--med"
												>
													<SliderCheckBox
														disabled={
															!isActive ||
															!productVirtualSkuField.$('isActive').value ||
															disableUpdateInventory(productVirtualSkuField.channelDropdownStore.value)
														}
														field={productVirtualSkuField.$('postInventory')}
													/>
													<ReactTooltip />
												</div>
											)}

											{_.get(productVirtualSkuField, 'channelDropdownStore.value.extra.channelType.name') ==
												channelType.amazon && (
												<div className="input--toggle--custom display--ib">
													<SliderCheckBox field={productVirtualSkuField.$('isNonPrime')} />
												</div>
											)}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
				<BaasicWarningModal modalParams={conflictWarningModal} />
				<ReactTooltip />
			</React.Fragment>
		);
	}
);

// Cant find a way to add the anchor to make it work with the translation file
const CarrierDropdownTooltip = ({ channel, rootStore }) => {
	if (channel != null) {
		return (
			<i className="fas fa-exclamation-circle spc--left--tny tooltip">
				<div className="tooltip">
					If you can't find the desired carrier for the SKU, make sure it's enabled for{' '}
					<a
						className="type--color--negative type--underline type--wgt--bold"
						onClick={() => {
							rootStore.routerStore.goTo('master.app.main.channel.edit', {
								id: channel.value,
							});
						}}
					>
						{channel.label}
					</a>{' '}
					channel on the Channels page
				</div>
			</i>
		);
	}
};

export { ProductEditGeneralStep, ProductEditDimensionsStep, ProductEditVirtualSKUStep };



// WEBPACK FOOTER //
// ./src/modules/product/wizard/pages/ProductEditSteps.jsx